<template>
  <div class="page withdraw-preview" :class="{countBottom: hasRetainCountDown && showRetainBanner}">
    <!-- 导航条 -->
    <navigation type="second-level" :sticky="true" @click="detention" :customClickEvent="true">预览提现</navigation>
    <!-- api 老用户 用户引导关注的 banner -->
    <guideApiFollow placeEnum="PREVIEW_LOAN"></guideApiFollow>
    <retainBanner v-if="showRetainBanner" :amt="loanPrin" :oldPreviewFloatViewResp="oldPreviewFloatViewResp" ref="retainBanner"></retainBanner>
    <!-- 预览信息 -->
    <section class="card-panel">
      <nd-cell v-if="!showRetainBanner" class="info-line" :arrow="false" title="提现金额 (元)"><span slot="text" style="color: #FF3446">{{loanPrin|currency}}</span></nd-cell>

      <nd-cell class="info-line" :arrow="false" title="分期期数" :text="`${loanTerm}期`"></nd-cell>

      <nd-cell class="info-line" :arrow="false" title="用途" :text="purposeText"></nd-cell>

      <nd-cell class="info-line shine" title="收款银行卡" :text="`${cardText}`" @click="goBankCard" data-sensors-click></nd-cell>

      <nd-cell class="info-line " title="优惠券"  @click="pushCouponList" data-sensors-click v-if="hasCanUseV3Coupon">
        <div slot="text" class="coupon-cell" v-if="selectCoupon.discountValue && couponSerialNoV3 !== 'NONE'"><img src="./image/img_coupon@2x.png" ><span class="coupon-type">免息</span><span class="coupon-info">{{selectCoupon.discountValue}}{{selectCoupon.discountType | unit}}</span></div>
        <div slot="text" class="coupon-cell" v-else><span class="un-select">未选优惠券，免息{{selectCoupon.discountValue}}{{selectCoupon.discountType | unit}}可用</span></div>
      </nd-cell>

      <nd-cell class="info-line " title="优惠券"  @click="pushCouponList" data-sensors-click v-else-if="!hasCanUseV3Coupon && loanCoupons && loanCoupons.length"><span slot="text" style="color:#999">无可用优惠</span></nd-cell>

      <!-- 大权益勾选样式一 -->
      <div
        v-if="loanProcess === 'GVIP' && initTrailConfig.gvipStyleShowTag==='STYLE_SHOW_TAG_A'"
        class="info-bvip" :class="{shine: checkGreatVIP === 'N'}"
        data-sensors-exposure-event-name="Element_Exposure"
        data-sensors-exposure-property-caseId="STYLE_SHOW_TAG_A"
      >
        <div class="bvip-title">
          <div style="display: flex; align-items: center;" data-sensors-click @click="checkGreatVIP = checkGreatVIP === 'Y' ? 'N' : 'Y'">
            <img v-if="checkGreatVIP == 'Y'" src="./image/circle_02@2x.png" class="title-img">
            <img v-else src="./image/circle_02_no@2x.png" class="title-img">
            <span>{{loanProcessTitle}}</span>
            <img src="./image/icon_info_w.png" class="title-tips" @click.stop="bvipVisible = true">
          </div>
          <div class="title-info" v-if="!isWHD">
            <span>{{greatVIPCoupon.termAmount | currency}}元/期</span>
            （共{{greatVIPCoupon.countTerm}}期）
          </div>
          <div
            class="bvip-mark"
            v-else
          >
            <span class="mark-item">99%用户选择</span>
            <span class="mark-item">最高价值{{ greatVIPCoupon.maxAmount}}元</span>
          </div>
        </div>
        <div class="bvip-info" :class="{border:showGVIPBorder}" v-if="!isWHD">
          <p>畅享专属特权大礼包，最高价值{{greatVIPCoupon.maxAmount}}元</p>
          <p class="bvip-user-choss">注：99%的用户选择了该权益</p>
        </div>

        <div v-else class="wh-title">
          <div class="title-info"><span class="color-primary">约{{ greatVIPCoupon.termAmount | currency }}元/期</span>（共{{ greatVIPCoupon.countTerm }}期）</div>
          <div class="bvip-user-choss">(以实际支付的金额为准)</div>
        </div>
    
      </div>

      <div class="info-other">
        <p class="other-title">其他借款信息</p>
        <p class="estimate-reduction" v-if="hasCanUseV3Coupon && couponTrailCashback.cashbackAmt && couponSerialNoV3 !== 'NONE'" @click="couponVisible=true"><img src="./image/icon_youhuiquan@2x.png">预计减免{{couponTrailCashback.cashbackAmt}}元 <img src="./image/icon_info2@2x.png"></p>
        <template v-if="maxIntRate&&maxInterestFee">
          <!-- <span class="through">¥{{maxInterestFee| currency}}</span> -->
          <p class="other-money">应还总息费(元)：<span>¥{{interestFee | currency}}</span></p>
          <!-- <span class="through">{{maxIntRate * 100| currency}}%</span> -->
          <p class="other-rate">综合年化利率(单利计算)：<span>{{intRate * 100 | currency}}%</span>
            <img class="other-img" @click="handleShowTips" src="./image/icon_info@3x.png" alt="">
          </p>
        </template>
        <template v-else>
          <p class="other-money">应还总息费(元)：¥{{interestFee | currency}}</p>
          <p class="other-rate">综合年化利率(单利计算)：{{intRate * 100 | currency}}%
            <img class="other-img" @click="handleShowTips" src="./image/icon_info@3x.png" alt="">
          </p>
        </template>
      </div>
    </section>

    <div class="repayment-schedule a" v-if="showCase === 'A'">
      <div class="cell-title">
        还款计划<em>（还款实际到期日以实际放款时间为准）</em>
      </div>

      <div class="schedule-list">
        <table>
          <thead>
            <tr class="table-header">
              <th width="20%">期数</th>
              <th width="35%">到期日</th>
              <th width="30%">当期应还(元)</th>
            </tr>
          </thead>
          <tbody style="padding: 31px 0;">
            <tr class="table-row" v-for="(item, index) in termInfo" :key="index">
              <td>{{ item.termNo }}/{{ termInfo.length }}</td>
              <td>{{ item.paidOutDate | date('YYYY/MM/DD') }}</td>
              <td>{{ item.schdAmt | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="repayment-schedule b" v-else>
      <div class="cell-title">
        还款计划<em>（还款实际到期日以实际放款时间为准）</em>
        <div class="show-detail" @click="toggle">{{ showDetail ? '收起详情': '查看详情'}}
          <img :style="{transform: showDetail?'rotate(-180deg)':'rotate(0deg)'}" src="./image/icon_01.png" srcset="
                            ./image/icon_01@2x.png 2x,
                            ./image/icon_01@3x.png,
                            3x
                        "
          />
        </div>
      </div>

      <div class="schedule-list" v-show="showDetail">
        <table>
          <thead>
            <tr class="table-header">
              <th width="35%">到期日</th>
              <th width="20%">期数</th>
              <th width="30%">当期应还(元)</th>
            </tr>
          </thead>
          <tbody style="padding: 31px 0;">
            <tr class="table-row" v-for="(item, index) in termInfo" :key="index">
              <td>{{ item.paidOutDate | date('YYYY/MM/DD') }}</td>
              <td>{{ item.termNo }}/{{ termInfo.length }}</td>
              <td>{{ item.schdAmt | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 大权益勾选样式二 -->
    <div
      v-if="loanProcess === 'GVIP' && initTrailConfig.gvipStyleShowTag==='STYLE_SHOW_TAG_B'"
      class="info-bvip2"
      data-sensors-exposure-event-name="Element_Exposure"
      data-sensors-exposure-property-caseId="STYLE_SHOW_TAG_B"
      :class="{shine: checkGreatVIP === 'N'}"
    >
      <div class="item" data-sensors-click >
        
        <span class="title">{{loanProcessTitle}}</span>
        <img
          src="./image/icon_info_w@2x.png"
          @click.stop="bvipVisible = true" class="title-tips"
        >
        <!-- <span class="subscript">会员福利</span>
        <span class="subscript">99%用户选择</span> -->
      </div>
      <div class="item">
        <span>畅享最高价值{{greatVIPCoupon.maxAmount}}元特权礼包</span>
      </div>
      <div class="pro-right-info">
        <div class="info-amout" @click="checkGreatVIP = checkGreatVIP === 'Y' ? 'N' : 'Y'" data-sensors-click>
          <span v-if="isWHD">约</span><span>{{greatVIPCoupon.termAmount | currency}}元/期 (共{{greatVIPCoupon.countTerm}}期)</span>
          <img v-if="checkGreatVIP == 'Y'" src="./image/selected_1@2x.png" class="title-img">
          <img v-else src="./image/default_1@2x.png" class="title-img">
        </div>
        <div class="whd-tips" v-if="isWHD">(请以实际支付的金额为准)</div>
      </div>

    </div>

    <!-- 立即提现区域 -->
    <section class="bottom" :class="{countBottom: hasRetainCountDown && showRetainBanner}">
      <!-- 挽留优惠券底部倒计时 -->
      <retain-count-down class="retain-count-down" ref="retain-count-down" v-if="showCountDown && showRetainBanner" :oldPreviewFloatViewResp="oldPreviewFloatViewResp" @on-countDownEnd="countDownEnd"></retain-count-down>
      <!-- 相关协议 -->
      <nd-button class="withdraw-btn" :disabled="!selectedBankcard.hasOwnProperty('bankCardNo') || cantWithdraw" @click="handlePreCheck">立即提现</nd-button>
      <section class="read-protocol">
        <span>点击「立即提现」按钮，表示您已阅读并同意<em @click.stop="viewProtocol">《相关协议》</em></span>
      </section>
    </section>

    <!-- 提现短信验证码 -->
    <nd-sms ref="smsRef" :duration="120" :showMobile="false" :tips="smsTips" title="短信认证" v-model="smsVisible" @retrieve="sendSmsAgain" @confirm="confirmWithdraw" @countEnd="countEnd" :errorTip="errorTip" @close="smsClose"></nd-sms>

    <!-- 强弹征信协议 -->
    <nd-dialog v-model="authenticationVisible" class="auth-dialog" :footer="false" :closeBtn="greyShow?false:true">
      <div class="default-content">
        <iframe ref="authIframe" @load="IframeLoaded" class="iframe" :src="authenticationProtocol" frameborder="0"></iframe>
      </div>
      <div class="btn-wrapper">
        <nd-button v-if="!greyShow" class="btn" @click="agreeAuthentication">我已完成阅读并同意上述协议</nd-button>
        <nd-button v-if="greyShow" :disabled="COUNT_DOWN > 0" class="btn" @click="agreeAuthentication">我已阅读并同意上述协议{{countdownSubfix}}</nd-button>
      </div>
    </nd-dialog>

    <nd-dialog v-model="rateTipsVisible" closeBtn :footer="false">
      <div class="rate-tips-title">综合年化利率说明</div>
      <div class="rate-tips-dialog">
        <p>该笔订单1年内用户需要承担的综合费用占本金的比率，1年以12个月计算。</p>
      </div>
    </nd-dialog>
    <bvip-intro-dialog v-model="bvipVisible" :content="greatVIPCoupon.couponPopupDesc"></bvip-intro-dialog>
    <bvip-pay-dialog v-model="bvipPayVisilbe" :repayBillNo="repayBillNo"></bvip-pay-dialog>
    <bvip-tips-dialog v-model="bBvipTipsVisible"  :loanProcessTitle="loanProcessTitle" @on-next="beforeWithdraw"></bvip-tips-dialog>
    <bvip-action-sheet v-model="bvipActionSheetVisible" :isWHD="isWHD" :loanProcessTitle="loanProcessTitle" :greatVIPCoupon="greatVIPCoupon" @on-protocol="viewProtocol" @on-withdraw="actionWithdraw"></bvip-action-sheet>

    <withdraw-action-sheet v-model="passCardDialogVisible"  @onTopAction="toVirtuuallyResult" ></withdraw-action-sheet>
    <detention-dialog v-model="oldGuestDetentionVisible" pageType="PREVIEW" @onGiveUp="goBack" :sensorsCaseId="loanDetentionType" >
      {{detentionText}}
    </detention-dialog>
    <!-- V3优惠券提示弹窗 -->
    <coupon-tips-dialog v-model="couponVisible"></coupon-tips-dialog>
  </div>
</template>
<script>
import NdSms from '../bankcard/components/nd-sms'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getKey, setKey, isEmptyObject } from '../../assets/utils'
import BvipIntroDialog from './components/bvip-intro-dialog.vue'
import BvipPayDialog from './components/bvip-pay-dialog.vue'
import withdrawConfig from '@/view/withdraw/assets/withdrawConfig.js'

const BASE_FORM = {
  applyAmt: '',
  applyTerm: '',
  purpose: '',
  bankCardNo: ''
}
      
export default {
  name: 'withdraw-preview',

  description: '提现预览',
  mixins: [withdrawConfig],
  components: {
    NdSms,
    BvipIntroDialog,
    BvipPayDialog,
    'withdraw-action-sheet': () => import('./components/withdraw-action-sheet.vue'),
    'detention-dialog': () => import('./components/detention-dialog.vue'),
    couponTipsDialog: () => import('./components/coupon-tips-dialog.vue'),
    retainBanner: () => import('./components/retain-banner'),
    'retain-count-down': () => import('./components/retain-count-down'),
    guideApiFollow: () => import('@/components/guide-api-follow/index.vue')
  },

  customReadyNotify: true,
  filters: {
    unit (type) {
      const map = {
        'FREE_AMOUNT': '元',
        'FREE_DAY': '天'
      }
      return map[type]
    }
  },
  data () {
    return {
      couponSerialNoV3: this.$route.query.couponSerialNoV3,
      loanCoupons: [],
      passCardProcess: this.$route.query.passCardProcess,
      passCardDialogVisible: false,
      couponVisible: false,
      showCase: 'A',
      greatVIPCoupon: {},
      messageTips: '您正在执行提现操作，提现验证码已发送您的手机，请查收',
      fundCode: this.$route.query.fundCode || this.$storage.get('fundCode'),
      riskTagProcess: this.$route.query.riskTagProcess,
      needLiveDetection: false, // 是否需要活体认证
      isPass: false, // 是否通过活体认证
      termInfo: [], // 还款试算
      smsVisible: false, // 是否显示短信验证码弹出框
      errorTip: '', // 短信验证码后端错误提示
      form: {
        // 提现表单
        ...BASE_FORM
      },
      selectedBankcard: {},
      loanTerm: '',
      bankcardList: [], // 银行卡列表
      schdAmt: '', // 还款总额
      loanPrin: '', // 还款本金
      loanApplyNo: '',
      interestFee: 0,
      intRate: 0,
      maxIntRate: 0,
      maxInterestFee: 0,
      canSendSms: true,
      showDetail: false,
      authenticationVisible: false,
      authenticationProtocol: '',
      greyShow: false, // 用来展示是否是灰度 包含大兴安岭资方灰度测试（不可点击
      COUNT_DOWN: 10,
      timer: null,
      rateTipsVisible: false,
      couponSerialNos: this.$route.query.couponSerialNos, // 券包运营活动跳转过来的券号
      couponType: this.$route.query.couponType, // 券包运营活动跳转过来的类型
      currentXiaomeiSelect: [], // 券包跳转默认旋转的券
      loanProcess: '', // 大权益开关，如果为GVIP则为开，从试算带过来的
      checkGreatVIP: 'Y', // 选择大权益
      checkGreatVIPProtocol: 'N', // 大权益协议
      showGVIPBorder: false,
      bvipVisible: false,
      repayBillNo: '',
      bvipPayVisilbe: false, 
      loanProcessTitle: '',
      loanProcessSupplier: '', // WHD 万恒 d
      initTrailConfig: {},
      needShowOldGuestDetentionPop: false, // 是否需要展示老客挽留弹窗
      oldGuestDetentionVisible: false, // 老客挽留弹窗
      loanDetentionType: '', // 老客挽留弹窗类型
      selectCoupon: {},
      couponTrailCashback: {},
      oldPreviewFloatViewResp: {},
      showCountDown: true,
      withdrawPending: false // 提现按钮是否禁用
    }
  },

  watch: {
    // 监听大权益的勾选，弹出toast
    checkGreatVIP (value) {
      // 监听大权益勾选，需要重置短信验证码
      this.canSendSms = true
      if (this.style === 'A') {
        this.$message('今日额度已抢完')
      }
      // this.getTermInfo()
    }
  },

  computed: {
    ...mapState('withdraw', {
      loanParameter: (state) => state.loanParameter,
      withdrawForm: (state) => state.withdrawForm
    }),
    isWHD () {
      return this.loanProcessSupplier === 'IRR36_XMPASS_WHD'
    },
    showRetainBanner () {
      if (this.oldPreviewFloatViewResp?.caseBizType === 'OLD_PREVIEW_B') {
        return true
      }
      
      if (!this.hasRetainCountDown || this.couponSerialNoV3 === 'NONE') {
        return false
      }
      
      if (this.oldPreviewFloatViewResp?.caseBizType === 'OLD_PREVIEW_A') {
        return this.oldPreviewFloatViewResp.bizVal === this?.selectCoupon.couponSerialNo
      }
      return false
    },
    hasRetainCountDown () {
      return this.oldPreviewFloatViewResp?.expTime - Date.now() > 0  
    },
    hasCanUseV3Coupon () {
      return !this.couponSerialNos && this.loanCoupons?.length && this.loanCoupons.some(item => item.canUse === 'Y')
    }, 
    
    ...mapState('user', ['userInfo']),

    countdownSubfix () {
      if (this.COUNT_DOWN > 0) {
        return ` (${this.COUNT_DOWN}S)`
      }
      return ''
    },

    ...mapState({
      dictionary: (state) => state.dictionary
    }),

    cardText () {
      if (this.selectedBankcard.bankCardNo) {
        const code = this.selectedBankcard.bankCardNo.substr(-4, 4)
        return `${this.selectedBankcard.bankName}(${code})`
      } else {
        return `去绑卡`
      }
    },

    purposeText () {
      if (isEmptyObject(this.dictionary)) return ''
      let purpose = this.dictionary.loanPurpose.filter(
        (pur) => pur.key === this.withdrawForm.purpose
      )[0]
      return purpose && purpose.description
    },

    smsTips () {
      return `<span>您正在执行提现操作，提现验证码已发送您的手机，请查收<em>${this.formatMobile(
        this.userInfo.mobile
      )}</em></span>`
    },

    clientWidth () {
      return document.documentElement.clientWidth + 'px'
    },
    detentionText () {
      return this.loanDetentionType === 'PREVIEW20' ? '免息' : '提额'
    }
  },
  async created () {   
    // 判断活体是否通过
    if (this.$route.query?.result === 'PASS') {
      this.isPass = this.$route.query.result === 'PASS'
      this.fundCode = this.$storage.get('fundCode')
    } else {
      this.isPass = false
    }

    this.generateWithdrawForm()
    await this.loanUseRecord()
    this.getTermInfo()
    this.getTrailInitConfig()
    try {
      await Promise.all([
        this.getUserInfoX(),
        this.fetchDictionaryX(),
        this.getLoanParameter(),
        this.getBankcardList()
      ])
      if (!getKey('withdrawButtonHasBeenClicked')) {
        this.getLoanDetentionType()
      } else {
        this.needShowOldGuestDetentionPop = !getKey('withdrawButtonHasBeenClicked')
      }
      this.$bus.$emit('ready')
      // 查看是否可自动提现
      this.canStartAutoWithdraw()
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  beforeRouteLeave (to, from, next) {
    this.setWithdrawForm(this.form)
    this.$storage.set('withdrawForm', this.form)
    next()
  },

  methods: {
    ...mapActions(['fetchDictionaryX']),

    ...mapActions('withdraw', [
      'getLoanParameterX',
      'loanApplyX',
      'preLoanApplyX',
      'loanConfirmX',
      'getLoanTrialX',
      'getLoanTrialXInitConfig',
      'getLoanDetentionPopType'
    ]),

    ...mapActions('user', ['getUserInfoX']),

    ...mapMutations('withdraw', ['setWithdrawForm']),

    ...mapActions('bankcard', ['getBankcardListX']),

    ...mapActions('coupon', ['loanUseRecordX']),
    // 短信关闭 重新刷新试算 当有 v3 优惠券的时候
    smsClose () {
      if (this.hasCanUseV3Coupon) {
        this.countDownEnd()
      }
    },
    removeFormStash () {
      this.form = BASE_FORM
      this.setWithdrawForm(BASE_FORM)
      this.$storage.set('withdrawForm', {})
    },
    handlePauseCountDown () {
      if (this.$refs['retain-count-down']) {
        this.$refs['retain-count-down'].stopCountDown()
      }
      this.showCountDown = false
    },
    async countDownEnd () {
      this.showCountDown = true
      await this.loanUseRecord()
      this.getTermInfo()
      this.getTrailInitConfig()
    },

    // 借款可用优惠券v3
    async loanUseRecord () {
      const response = await this.loanUseRecordX({
        loanAmt: this.form.applyAmt
      })
      if (response.success) {
        this.loanCoupons = response.data || []
        const couponSerialNoV3 = this.couponSerialNoV3 || sessionStorage.getItem('couponSerialNoV3')
   
        if (couponSerialNoV3 && couponSerialNoV3 !== 'NONE') {
          this.selectCoupon = this.loanCoupons.find(item => (item.couponSerialNo === couponSerialNoV3 && item.canUse === 'Y')) || {}
        }
        if (this.selectCoupon?.couponSerialNo) return
        // 默认选择一张
        if (this.loanCoupons?.length && this.loanCoupons.some(item => item.canUse === 'Y' && item.defaultCheck === 'Y')) {
          this.selectCoupon = this.loanCoupons.find(item => item.canUse === 'Y' && item.defaultCheck === 'Y')
        }
      }
    },

    toVirtuuallyResult () {
      this.$router.replace(`/withdraw/result4?loanApplyNo=${this.loanApplyNo}`)
    },

    pushCouponList () {
      const { query } = this.$route

      const params = {
        couponSerialNoV3: this.selectCoupon.couponSerialNo,
        applyAmt: this.form.applyAmt,
        ...query
      }
      if (params.couponSerialNoV3 === 'NONE') {
        delete (params.couponSerialNoV3)
      }
      this.$router.push({
        path: '/coupon/list',
        query: params
      })
    },
    actionWithdraw () {
      this.checkGreatVIP = 'Y'
      this.beforeWithdraw()
    },
    countdown () {
      this.timer = setInterval(() => {
        if (this.COUNT_DOWN < 1) {
          clearInterval(this.timer)
        } else {
          this.COUNT_DOWN--
        }
      }, 1000)
    },

    // 获取银行卡列表
    async getBankcardList () {
      const response = await this.getBankcardListX({
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        productCd: 'TMDP'
      })
      if (response.success && response.data.length > 0) {
        const bank = this.$store.state.bankcard.selectedBankcard
        const defaltBankFilter = response.data.filter(
          (item) => item.defalt
        )
        const defaltBank =
          defaltBankFilter.length > 0 ? defaltBankFilter[0] : null
        this.selectedBankcard = !isEmptyObject(bank) && response.data.filter(item => item.bankCardNo === bank.bankCardNo).length !== 0
          ? response.data.filter(item => item.bankCardNo === bank.bankCardNo)[0]
          : defaltBank || response.data[response.data.length - 1]
      }
    },

    // 获取是否需要活体
    async getLoanParameter () {
      const params = {
        loanPlatform: 'TMD'
      }
      if (this.riskTagProcess) {
        params.riskTagProcess = this.riskTagProcess
      }
      const response = await this.getLoanParameterX(params)
      if (response.success) {
        this.needLiveDetection = response.data.needLiveDetection
      } else {
        throw new Error('获取借款参数失败')
      }
    },

    // 获取试算初始化配置
    async getTrailInitConfig () {
      const { success, data } = await this.getLoanTrialXInitConfig()
      this.oldPreviewFloatViewResp = data?.oldPreviewFloatViewResp || {}
      if (success && data && data.loanProcess === 'GVIP') {
        this.initTrailConfig = data
        // this.initTrailConfig.gvipStyleShowTag = 'STYLE_SHOW_TAG_B'
        this.mustCheck = data.mustCheck
        this.complianceConfig = data.complianceConfig
        this.checkGreatVIP = data.complianceConfig?.defaultCheck
      } else {
        this.checkGreatVIP = ''
      }
    },

    // 获取分期信息
    async getTermInfo () {
      const params = {
        loanTerm: this.form.applyTerm,
        withdrawAmt: this.form.applyAmt,
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        repayMethod: 'AI',
        productCd: 'TMDP',
        checkGreatVIP: this.checkGreatVIP
      }
      if (this.riskTagProcess) {
        params.riskTagProcess = this.riskTagProcess
      }

      // 如果有 V3 免息券并且可用
      if (this.hasCanUseV3Coupon && this.selectCoupon?.couponSerialNo && this.couponSerialNoV3 !== 'NONE') {
        params.couponSerialNoV3List = [this.selectCoupon.couponSerialNo]
      }

      if (this.couponSerialNoV3 === 'NONE' && this.hasCanUseV3Coupon) {
        params.userGiveUpCouponV3 = 'Y'
      }

      const { success, data } = await this.getLoanTrialX(params)

      if (success) {
        const repayTrail = data
        this.$set(this, 'termInfo', repayTrail.termInfo)
        this.schdAmt = repayTrail.schdAmt
        this.loanPrin = repayTrail.loanPrin
        this.loanTerm = repayTrail.loanTerm
        this.showCase = repayTrail.showCase
        this.interestFee = repayTrail.interestFee
        this.maxIntRate = repayTrail.maxIntRate
        this.maxInterestFee = repayTrail.maxInterestFee
        this.intRate = repayTrail.intRate
        this.loanProcess = repayTrail.loanProcess
        this.greatVIPCoupon = repayTrail.greatVIPCoupon || {}
        this.loanProcessTitle = repayTrail.loanProcessTitle 
        this.loanProcessSupplier = repayTrail.loanProcessSupplier
        this.couponTrailCashback = repayTrail.couponTrailCashback || {}
      }
    },

    // 查看相关协议
    viewProtocol () {
      this.$router.push({
        path: '/withdraw/protocol',
        query: {
          fundCode: this.fundCode,
          busiType: 'LOAN',
          loanProcess: this.loanProcess
        }
      })
    },

    // 查看大权益勾选协议
    viewGVIPProtocol (url) {
      window.location.href = url
    },

    // 获取提现表单数据，如果state没有就从本地缓存中获取，都没有页面就会报错
    generateWithdrawForm () {
      if (
        !isEmptyObject(this.withdrawForm) &&
        this.withdrawForm.applyAmt !== 0 && this.withdrawForm.applyAmt
      ) {
        this.form = this.withdrawForm
      } else {
        this.form = this.$storage.get('withdrawForm')
        this.setWithdrawForm(this.form)
      }
    },

    // 发起活体认证
    startAuth () {
      this.$storage.set('loanApplyNo', this.loanApplyNo)
      this.$storage.set('fundCode', this.fundCode)
      this.$router.replace('/authentication/face?redirectUrl=/withdraw/preview')
    },
 
    // 短信失效或者错误 - 再次发起申请
    async sendSmsAgain (reset) {
      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      const params = {
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        applyAmount: this.loanPrin,
        loanPurpose: this.withdrawForm.purpose,
        totatlTermNo: this.loanTerm,
        bindCardDto: this.selectedBankcard,
        loanProcess: this.loanProcess,
        ...trafficCode
      }
      if (this.couponSerialNos) {
        params.couponSerialNos = [this.couponSerialNos]
      }

      /**
       * && this.hasCanUseV3Coupon 是为了区分是不是真的放弃，从新优惠券列表跳转过来的
       * 如果真的没有优惠券，就是放弃了
       */
      
      if (this.couponSerialNoV3 === 'NONE' && this.hasCanUseV3Coupon) {
        params.userGiveUpCouponV3 = 'Y'
      }
      if (this.loanProcess === 'GVIP') {
        params.checkGreatVIP = this.checkGreatVIP
      }
      if (this.passCardProcess) {
        params.passCardProcess = this.passCardProcess
      }
      if (this.riskTagProcess) {
        params.riskTagProcess = this.riskTagProcess
      }
      // 如果有 V3 免息券并且可用
      if (this.hasCanUseV3Coupon && this.selectCoupon?.couponSerialNo && this.couponSerialNoV3 !== 'NONE') {
        params.couponSerialNoV3List = [this.selectCoupon.couponSerialNo]
      }
      const response = await this.loanApplyX(params)
      if (response.success) {
        // 如果有需要还款的大权益账单，则优先跳转到账单还款页面
        if (response.data.haveRepayBill && response.data.repayBillNo) {
          this.repayBillNo = response.data.repayBillNo
          this.bvipPayVisilbe = true
          return
        }
        this.loanApplyNo = response.data.loanApplyNo
        this.$sensors.track('parameters_report', { page_status: 'withdraw', caseid: this.loanApplyNo })
        this.canSendSms = false
        reset()
      } else {
        if (response.code === '000028') {
          this.loanApplyNo = response.msg
          this.canSendSms = false
          reset()
        } else {
          this.$message(response.msg)
        }
      }
    },
    // 用于协议数据填充留资料
    async fillData () {
      return new Promise(async (resolve) => {
        if (['ZYXJ'].includes(this.fundCode)) {
          await this.preLoanApplyX({
            loanPlatform: 'TMD',
            fundCode: this.fundCode,
            applyAmount: this.loanPrin,
            loanPurpose: this.withdrawForm.purpose,
            totatlTermNo: this.loanTerm,
            bindCardDto: this.selectedBankcard,
            loanProcess: this.loanProcess
          })
        }
        resolve()
      })
    },
    // 新合规流程校验  mixins: withdrawConfig
    handlePreCheck () {
      if (this.style === 'B') {
        this.showStyleB()
        return
      }
      if (this.showDialogTips) {
        this.bBvipTipsVisible = true
        return
      }
      if (this.unCheckLead) {
        this.bvipActionSheetVisible = true
        return
      }
      this.beforeWithdraw()
    },
    // 点击提现
    async beforeWithdraw () {
      setKey('withdrawButtonHasBeenClicked', true)
      this.needShowOldGuestDetentionPop = false

      const fundRoute = this.$storage.get('fundRoute')
      if (fundRoute.forceReads && fundRoute.forceReads.length > 0) {
        const gid = getKey('gid')
        const { mobile, userId } = getKey('userInfo') || {}
        const qsString = `gid=${gid}&userId=${userId}&phoneNumber=${mobile}&hideNav=Y`
        const url = fundRoute.forceReads[0].contractUrl
        this.authenticationProtocol = url.includes('?')
          ? `${url}&${qsString}`
          : `${url}?${qsString}`

        await this.fillData()
        this.greyShow = fundRoute.greyShow
        this.authenticationVisible = true
        if (this.greyShow) {
          this.COUNT_DOWN = 10
          this.countdown()
        }
        this.$nextTick(() => {
          this.$refs['authIframe'].contentWindow.postMessage({
            type: 'setFontSize',
            value: document.documentElement.style.fontSize
          }, '*')
        })
      } else {
        this.applyWithdraw()
      }
    },

    IframeLoaded () {
      this.$nextTick(() => {
        this.$refs['authIframe'].contentWindow.postMessage({
          type: 'setFontSize',
          value: document.documentElement.style.fontSize
        }, '*')
      })
    },

    agreeAuthentication () {
      this.authenticationVisible = false
      this.applyWithdraw()
    },
    // 倒计时结束可再次发送验证码
    countEnd () {
      this.canSendSms = true
    },

    // 重新绑卡
    reBindBankcard () {
      this.$router.push({
        path: '/bankcard/add',
        query: {
          position: 'loan',
          loanPlatform: 'TMD',
          fundCode: this.fundCode,
          productCd: 'TMDP',
          bankMobile: this.selectedBankcard.bankMobile,
          bankcardNo: this.selectedBankcard.bankCardNo,
          canChangePhoneNo: this.selectedBankcard.canChangePhoneNo
        }
      })
    },
    // 申请提现
    async applyWithdraw () {
      if (this.selectedBankcard.invalid) {
        return this.reBindBankcard()
      }
      this.errorTip = ''
      if (!this.canSendSms) {
        this.smsVisible = true
        return
      }
      // 全部完成 -> 去授信
      await this.riskReport(3)

      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      const params = {
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        applyAmount: this.loanPrin,
        loanPurpose: this.withdrawForm.purpose,
        totatlTermNo: this.loanTerm,
        bindCardDto: this.selectedBankcard,
        loanProcess: this.loanProcess,
        ...trafficCode
      }
      if (this.couponSerialNos) {
        params.couponSerialNos = [this.couponSerialNos]
      }
      if (this.couponSerialNoV3 === 'NONE' && this.hasCanUseV3Coupon) {
        params.userGiveUpCouponV3 = 'Y'
      }
      if (this.loanProcess === 'GVIP') {
        params.checkGreatVIP = this.checkGreatVIP
      }

      if (this.passCardProcess) {
        params.passCardProcess = this.passCardProcess
      }

      if (this.riskTagProcess) {
        params.riskTagProcess = this.riskTagProcess
      }


      // 如果有 V3 免息券并且可用
      if (this.hasCanUseV3Coupon && this.selectCoupon?.couponSerialNo && this.couponSerialNoV3 !== 'NONE') {
        params.couponSerialNoV3List = [this.selectCoupon.couponSerialNo]
      }

      // 暂停倒计时
      const response = await this.loanApplyX(params)
      if (response.code === '100018') {
        this.reBindBankcard()
        return
      }
      if (response.success) {
        this.handlePauseCountDown()

        // 如果有需要还款的大权益账单，则优先跳转到账单还款页面
        if (response.data.haveRepayBill && response.data.repayBillNo) {
          this.repayBillNo = response.data.repayBillNo
          this.bvipPayVisilbe = true
          return
        }
        this.loanApplyNo = response.data.loanApplyNo
        this.$sensors.track('parameters_report', { page_status: 'withdraw', caseid: this.loanApplyNo })
        if (this.needLiveDetection && !this.isPass) {
          return this.startAuth()
        }
        this.canSendSms = false
        this.$refs.smsRef.reset()
        this.smsVisible = true
      } else {
        if (response.code === '000028') {
          this.smsVisible = true
          this.canSendSms = false
          this.loanApplyNo = response.msg
        } else {
          this.$message(response.msg)
        }
      }
    },

    // 确认提现
    async confirmWithdraw (code = '') {
      if (this.withdrawPending) return
      this.withdrawPending = true
      const response = await this.loanConfirmX({
        loanApplyNo: this.loanApplyNo,
        smsCode: code
      })
      this.withdrawPending = false
      if (response.success) {
        this.removeFormStash()
        this.$statistics('WITH_SUB_SUC')
        this.$storage.remove('fundCode')

        if (response.data.openPayDialog === 'Y') {
          this.toVirtuuallyResult()
          return
        }

        if (getKey('channel') === 'API-XHQB') {
          window.location.href = response.data.jumpUrl
          return
        }

        if (this.riskTagProcess) {
          this.$router.replace(
            `/withdraw/result5?loanApplyNo=${response.data.loanApplyNo}&noDialog=T`
          )
          return
        }
        this.$router.replace(
          `/withdraw/result?loanApplyNo=${response.data.loanApplyNo}&noDialog=T`
        )
      } else {
        this.$statistics('WITH_SUB_FAIL', {
          comment: response.msg
        })
        if (response.code === '200001') {
          window.location.href = getKey('successUrl')
        }
        if (response.code === '000010') {
          this.errorTip = response.msg
        }
        if (response.code === '100007') {
          this.errorTip = response.msg
        }
      }
    },

    // 是否可以发起自动提现 - 活体认证返回
    canStartAutoWithdraw () {
      if (this.isPass) {
        this.loanApplyNo = this.$storage.get('loanApplyNo')
        this.confirmWithdraw()
      }
    },

    // 去绑卡
    goBankCard () {
      if (!isEmptyObject(this.selectedBankcard)) {
        this.$router.push({
          path: '/bankcard/list',
          query: {
            loanPlatform: 'TMD',
            fundCode: this.fundCode,
            productCd: 'TMDP'
          }
        })
      } else {
        this.$router.push({
          path: '/bankcard/add',
          query: {
            position: 'loan',
            loanPlatform: 'TMD',
            fundCode: this.fundCode,
            productCd: 'TMDP'
          }
        })
      }
    },
    toggle () {
      this.showDetail = !this.showDetail
    },
    // 显示年化利率的弹窗
    handleShowTips () {
      this.rateTipsVisible = true
    },
    // 监听大权益协议的勾选
    clickGreatVIPProtocol () {
      this.checkGreatVIPProtocol = this.checkGreatVIPProtocol === 'Y' ? 'N' : 'Y'
    },
    // todo: mock & 联调
    async getLoanDetentionType () {
      const { success, data } = await this.getLoanDetentionPopType({
        reqType: 'PREVIEW'
      })
      if (success && data) {
        this.loanDetentionType = data.loanPopType
        this.needShowOldGuestDetentionPop = ['PREVIEW20', 'PREVIEW50'].includes(data.loanPopType)
      } else {
        this.needShowOldGuestDetentionPop = false
      }
    },
    detention () {
      if (this.isApiH5) {
        this.goBack()
        return 
      }
      if (this.needShowOldGuestDetentionPop) {
        this.oldGuestDetentionVisible = true
        return
      }
      this.goBack()
    },
    goBack () {
      window.history.go(-1)
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

@keyframes shine {
  0% {
    background-color: #ffddd9;
  }

  20% {
    background-color: #ffffff;
  }

  40% {
    background-color: #ffddd9;
  }

  60% {
    background-color: #ffffff;
  }

  80% {
    background-color: #ffddd9;
  }

  100% {
    background-color: #ffffff;
  }
}

@keyframes newShine {
  0% {
    background-color: #ffffff;
  }

  16.7% {
    background-color: #ffddd9;
  }

  33.3% {
    background-color: #ffffff;
  }

  50% {
    background-color: #ffddd9;
  }

  66.7% {
    background-color: #ffffff;
  }

  83.3% {
    background-color: #ffddd9;
  }

  100% {
    background-color: #ffffff;
  }
}
.estimate-reduction {
  display: flex;
  position: absolute;
  padding:0 15px;
  height: 42px;
  background: #FFEFE8;
  border-radius: 100px 100px 100px 0px;
  border: 1px solid #F6DED3;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #B13314;
  left: 240px;
  top: 40px;
  gap:4px;
  img:nth-of-type(1){
    width: 36px;
    height: 27px;
  }img:nth-of-type(2){
    width: 24px;
    height: 24px;
  }
}
.coupon-cell {
  display: flex;
  align-items: center;
  gap:4px;
  font-size: 30px;
  .un-select {
    color: #AAAAAA;
  }
  .coupon-info {
    color:#FF4633
  }
  img {
    width:78px;
    height:34px;
  }
}
.through {
  text-decoration: line-through;
  padding-right: 15px;
}

.withdraw-preview {
  padding-bottom: 240px;
  min-height: 100%;
  box-sizing: border-box;
  background-color: RGBA(250, 250, 250, 1);
  &.countBottom {
    padding-bottom: 300px;
  }
  .info-bvip2 {
    display: flex;
    flex-direction: column;
    background: #fff;
    margin: 20px 0;
    padding: 30px;
    position: relative;
    &.shine {
      animation: newShine 3000ms infinite;
    }
    .pro-right-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 24px;
      position: absolute;
      right: 30px;
      bottom: 32px;
      .whd-tips {
        color: #aaa;
        padding-right: 30px;
      }
      .info-amout {text-align: right; margin-bottom: 6px;}
      .title-img {
        width: 24px;
        height: 24px;
        font-size: 24px;
      }
    }
    .item {
      display: flex;
      align-items: center;
      position: relative;
      
      .title{
        font-size: 30px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .title-tips {
        width: 26px;
        height: 26px;
        margin-left: 5px;
      }
      .subscript{
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FF4633;
        border:1px solid #FF4633; border-radius: 4px;
        padding:4px 10px;
      }
    }
    .item:nth-last-of-type(1) {
      font-size: 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      display: flex;
      justify-content: space-between;
      padding-top: 5px;
    }
  }

  .card-panel {
    margin-top: 20px;

    .info-line {
      height: 100px;
      line-height: 100px;
      border-bottom: 1px solid #eee;
      position: relative;
      margin-bottom: 1px;
      font-size: 30px;
      color: rgba(51, 51, 51, 1) !important;

      &:last-child {
        animation: shine 2000ms step-end;
        // background-color: #FFDDD9 !important;
      }

      .custom-icon {
        display: block;
        width: 30px;
        height: 30px;
        /*background-image: url(../../assets/img/withdraw-preview/icon_explain@3x.png);*/
        background-size: 100%;
        float: right;
        position: relative;
        top: 35px;
        margin-left: 10px;
      }

      .weight {
        font-size: 34px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #20c7c7;
      }
    }

    .info-bvip {
      background: url(./image/img_shou@2x.png) 514px 50px no-repeat #fff;
      background-size: 220px 206px;
      background-color: white;
      margin-top: 20px;
      padding: 38px 20px 30px 40px;

      .bvip-mark {
        display: flex;
        gap:10px;
        padding-left: 10px;
        .mark-item {
          background: #FFF2EB;
          padding: 0 10px;
          font-size: 22px;
          color: #9E5736;
          border-radius: 8px;
        }
       }

      &.shine {
        animation: newShine 3000ms infinite;
      }

      .bvip-title {
        font-size: 30px;
        color: #333333;
        line-height: 50px;
        display: flex;
        align-items: center;
        font-weight: bold;

        .title-img {
          width: 32px;
          height: 32px;
          margin-right: 19px;
        }

        .title-tips {
          width: 24px;
          height: 24px;
          margin-left: 10px;
        }

       
      }

       .title-info {
          font-size: 30px;
          color: #333333;
          line-height: 50px;
          display: flex;
          align-items: center;
          font-weight: bold;
          span {
            color: #FF4633;
          }
        }
        .wh-title {
          margin-left: 45px;
          .title-info{
          padding-left: 3px;
          }
          .title-info {
            margin: 12px 0 2px 0;
          }
        }

      .bvip-info {
        font-size: 26px;
        color: #666666;
        line-height: 50px;
        margin-left: 50px;
        margin-right: 20px;
        padding-bottom: 16px;
        &.border {
          border-bottom: 1px solid #eee;
        }
      }
      .bvip-user-choss{
        font-size: 22px;
        box-sizing: border-box;
        height: 34px;
        line-height:34px;
        padding: 0px 5px;
        // border: 1px solid #FF4633;
        color: #aaa;
        border-radius: 3px;
      }

      .bvip-protocol {
        margin-top: 13px;
        font-size: 30px;
        color: #333333;
        line-height: 50px;
        display: flex;
        font-weight: bold;

        .protocol-img {
          width: 32px;
          height: 32px;
          margin-top: 14px;
        }
        .read-protocol {
          margin-left: 10px;
          flex:1;
          span {
            font-family: 'PingFangSC-Regular';
            font-weight: 400;
            color: #666;
            font-size: 24px;
            display: block;
            line-height: 30px;

            em {
              font-style: normal;
              color: rgba(142, 178, 216, 1);
              margin-left: 2px;
            }
          }
    }
      }

      .bvip-tips {
        font-size: 24px;
        color: #999999;
        line-height: 50px;
        padding-left: 50px;
      }
    }


    .info-other {
      width: 100%;
      background-color: #fff;
      margin-top: 21px;
      padding: 28px 30px;
      position: relative;

      .other-title {
        color: #333333;
        font-size: 30px;
      }

      .other-money {
        color: #999999;
        font-size: 26px;
        margin-top: 15px;
      }

      .other-rate {
        color: #999999;
        font-size: 26px;
        margin-top: 10px;

        .other-img {
          width: 26px;
          height: 26px;
          vertical-align: -3px;
        }
      }
    }
  }

  .repayment-schedule {
    margin: 40px 30px 0;
    border-radius: 10px;

    &.b {
      background-color: #fff;

      .cell-title {
        padding: 33px 40px;

        .show-detail {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(142, 178, 216, 1);
          line-height: 50px;

          >img {
            width: 29px;
            height: 29px;
            margin-left: 8px;
            transition: all .3s;
          }
        }
      }
    }

    .cell-title {
      font-size: 32px;
      line-height: 50px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;

      em {
        font-size: 26px;
        font-style: normal;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: @fc3;
      }
    }

    .schedule-list {
      margin-top: 22px;
      padding-bottom: 20px;
      background-color: #ffffff;
      border-radius: 10px;

      table {
        width: 100%;
        border-spacing: 0px;

        .table-header {
          th {
            font-size: 27px;
            height: 50px;
            line-height: 50px;
            padding-top: 23px;
            padding-bottom: 7px;
            border-bottom: 1px solid @iuc;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }
        }

        .table-row {
          td {
            height: 50px;
            line-height: 50px;
            font-size: 22px;
            padding-top: 10px;
            text-align: center;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          &+.table-row {
            td {
              padding-top: 2px;
            }
          }
        }
      }
    }
  }

  >.bottom {
    width: 750px;
    height: 230px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.04);
    position: fixed;
    bottom: 0;
    &.countBottom {
      height: 264px ;
      padding-top: 60px;
    }
    .read-protocol {
      width: 100%;
      text-align: center;
      margin-top: 25px;

      span {
        font-family: 'PingFangSC-Regular';
        font-weight: 400;
        color: #666;
        font-size: 24px;
        line-height: 33px;
        display: block;
        em {
          font-style: normal;
          color: rgba(142, 178, 216, 1);
          margin-left: 5px;
          margin-right: 5px;
        }
      }
    }

    .withdraw-btn {
      width: 670px;
      height: 94px;
      border-radius: 47px;
      margin: 30px auto 0;
      position: relative;
    }
  }

  .auth-dialog {
    .default-content {
      width: 620px;
      border-radius: 30px 30px 0 0;
      padding-top: 40px;
      background: white;
      height: 638px;
      overflow: auto;

      .dialog-title {
        text-align: center;
        font-size: 36px;
        padding-bottom: 15px;
        font-weight: 600;
      }

      .dialog-footer {
        padding: 0 50px;
        padding-bottom: 40px;
        display: flex;
        justify-content: space-between;
        background-color: #FFFFFF;

        .btn {
          width: 240px;
          height: 80px;
          line-height: 80px;
        }
      }
    }

    .iframe {
      height: 638px;
      width: 100%;

      html {
        width: 100%;
      }
    }

    .btn-wrapper {
      position: fixed;
      background: white;
      height: 162px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 620px;
      border-radius: 0 0 30px 30px;
      transform: translateY(-20px);

      .btn {
        width: 500px;
      }
    }
  }

  /deep/ .rate-tips-title {
    font-size: 42px;
    color: #333333;
    font-weight: bold;
    padding-left: 40px;
  }

  .rate-tips-dialog {
    padding: 40px 40px 60px;
    color: #666666;
    font-size: 28px;
  }
}
</style>